import React, { Component } from 'react';
import moment from 'moment';
import { toUSD } from '../../helpers/formatters';

import Dropdown from '../../components/application/dropdown/index';
import DropdownItem from '../../components/application/dropdown/item';

// Import assets
import scheduledImg from '../../assets/images/scheduled.png';
import declinedImg from '../../assets/images/declined.png';
import deletedImg from '../../assets/images/deleted.png';

class ScheduleReceipt extends Component {
  state = {
    isOptionsDisplayed: false
  }

  /**
   * Get the stamp according to the status of the scheduled payment.
   */
  getStamp() {
    let stampImg = scheduledImg;

    if (this.props.status === '2') {
      stampImg = declinedImg;
    } else if (this.props.status === '3') {
      stampImg = deletedImg;
    }

    return stampImg;
  }

  /**
   * Display or hidden the receipt options dropdown.
   */
  displayOptions = () => {
    let status = !this.state.isOptionsDisplayed;

    this.setState({
      isOptionsDisplayed: status
    });
  }

  /**
   * Handle the event to edit a specific scheduled payment.
   * 
   * @param id
   */
  handleEdit = (id) => {
    this.displayOptions();
    this.props.onEdit(id);
  }

  /**
   * Handle the event to edit a specific scheduled payment.
   * 
   * @param id
   */
  handleRecurringEdit = (id) => {
    this.displayOptions();
    this.props.onRecurringEdit(id);
  }

  /**
   * handle the event to delete a specific scheduled payment.
   * 
   * @param id
   */
  handleDelete = (id) => {
    this.displayOptions();
    this.props.onDelete(id);
  }


  handleRecurringDelete = (id) => {
    this.displayOptions();
    this.props.onRecurringDelete(id);
  }


  /**
   * Get the description for the frequency of the schedule.
   */
  getFrequency = () => {
    let frequency = this.props.frequency;
    let shortDescription = {
      recurring: '',
      freq: 'ONE TIME'
    };

    if (this.props.scheduleType !== '1') {
      let index = frequency.indexOf("|");

      if (index !== -1) {
        //shortDescription = frequency.substr(0, (index - 1));
        //shortDescription = 'Recurring'
        shortDescription = {
          recurring: 'Recurring',
          freq: frequency.substr(0, (index - 1))
        };
      }
    }

    return shortDescription;
  }

  renderOptions = () => {
    if (this.props.status !== '0') {
      return null
    }
    //change edit and delete off of this.props.can.edit and delete
    if(!this.props.can.edit && !this.props.can.delete){
      return (
        <div style={{right:'10px'}} className="receipt__options-wrapper text-center">
          Call to Edit
        </div>
      )
    }else{
      if(this.props.recurringId){
        if(this.props.can.edit && this.props.can.delete){
          return (
            <div className="receipt__options-wrapper">
              <Dropdown alignToRight={true} className="options-dropdown" handler={() =>
                <i className="fas fa-ellipsis-v size-16 icon--20px color-gray"></i>
              }>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleEdit}>
                  Edit One-Time Payment
                </DropdownItem>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleRecurringEdit}>
                  Edit Recurring Schedule
                </DropdownItem>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleDelete}>
                  Delete One-Time Payment
                </DropdownItem>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleRecurringDelete}>
                  Delete Recurring Schedule
                </DropdownItem>
              </Dropdown>
            </div>
          )
        }else if (this.props.can.edit && !this.props.can.delete){
          return (
            <div className="receipt__options-wrapper">
              <Dropdown alignToRight={true} className="options-dropdown" handler={() =>
                <i className="fas fa-ellipsis-v size-16 icon--20px color-gray"></i>
              }>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleEdit}>
                  Edit One-Time Payment
                </DropdownItem>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleRecurringEdit}>
                  Edit Recurring Schedule
                </DropdownItem>
              </Dropdown>
            </div>
          )
        }else if (this.props.can.delete && !this.props.can.edit){
          return (
            <div className="receipt__options-wrapper">
              <Dropdown alignToRight={true} className="options-dropdown" handler={() =>
                <i className="fas fa-ellipsis-v size-16 icon--20px color-gray"></i>
              }>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleDelete}>
                  Delete One-Time Payment
                </DropdownItem>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleRecurringDelete}>
                  Delete Recurring Schedule
                </DropdownItem>
              </Dropdown>
            </div>
          )
        }
        
      }else{
        if (this.props.can.delete && this.props.can.edit){
          return (
            <div className="receipt__options-wrapper">
              <Dropdown alignToRight={true} className="options-dropdown" handler={() =>
                <i className="fas fa-ellipsis-v size-16 icon--20px color-gray"></i>
              }>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleEdit}>
                  Edit
                </DropdownItem>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleDelete}>
                  Delete
                </DropdownItem>
              </Dropdown>
            </div>
          )
        }else if (this.props.can.delete && !this.props.can.edit){
          return (
            <div className="receipt__options-wrapper">
              <Dropdown alignToRight={true} className="options-dropdown" handler={() =>
                <i className="fas fa-ellipsis-v size-16 icon--20px color-gray"></i>
              }>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleDelete}>
                  Delete
                </DropdownItem>
              </Dropdown>
            </div>
          )
        }else if (this.props.can.edit && !this.props.can.delete){
          return (
            <div className="receipt__options-wrapper">
              <Dropdown alignToRight={true} className="options-dropdown" handler={() =>
                <i className="fas fa-ellipsis-v size-16 icon--20px color-gray"></i>
              }>
                <DropdownItem className="options-dropdown__item" value={this.props.id} onClick={this.handleEdit}>
                  Edit
                </DropdownItem>
              </Dropdown>
            </div>
          )
        }
      }
    }
  }

  /**
   * Render the component view.
   */
  render() {
    let { loanAccount, paymentMethod } = this.props;
    let collateral = loanAccount.loanCollateral;
    let date = moment(this.props.date.date);

    // We suppose that the payment method is card default, else override the info.
    let brand = null;
    let lastFour = null;

    if (paymentMethod.paymentType === 2) { // Account bank
      brand = paymentMethod.bankName;
      lastFour = paymentMethod.lastFour;
    } else if (paymentMethod.paymentType === 3) { // Account bank
      brand = paymentMethod.bankName;
      lastFour = paymentMethod.lastFour;
    }else{
      brand = paymentMethod.cardBrand;
      lastFour = paymentMethod.lastFour;
    }



    return (
      <div className="receipt schedule-receipt">
        <div className="receipt__left-content">

          {/**
            ** Left content
            **/}
          <div className="receipt__data-section">
            <span className="money money--block money--green congratulations-modal__value">
              {toUSD(this.props.amount + this.props.convenienceFee)}
            </span>


          </div>

          <div className="receipt__data-section">
            <p className="receipt__value">{toUSD(this.props.convenienceFee)}</p>
            <span className="receipt__label">{this.props.whiteLabel.labels['Convenience Fee']}</span>
          </div>

          <div className="receipt__data-section">
            <p className="receipt__value">
              {(collateral.collatYear !== '' && collateral.collatMake !== '') 
                ? `${collateral.collatYear} ${collateral.collatMake}`
                : ''
              }
            </p>
            <span className="receipt__label">
              {(collateral.collatModel !== '') 
                ? loanAccount.loanCollateral.collatModel
                : ''
              }
            </span>
          </div>

          <div className="receipt__data-section">
            <p className="receipt__value">{loanAccount.loanNo}</p>
            <span className="receipt__label">{this.props.whiteLabel.labels['ACCOUNT NUMBER']}</span>
          </div>

          <div className="receipt__data-section">
            <p className="receipt__value">{brand}</p>
            <span className="receipt__label">**{lastFour}</span>
          </div>
          {this.props.recurringId?<span><span className="receipt__value">Group: {this.props.recurringId}</span></span>:''}
        </div>

        {/**
          ** Right content
          **/}
          
        <div className="receipt__right-content">
          <div className="text-center">
            <img className="receipt__impress" src={this.getStamp()} alt="" />
          </div>
          <p className="text-center">
           {/**
              ** 1 is only once payment and 2 is recurring payment.
              **/}
            <span className="receipt__value nowrap-text">{this.getFrequency().freq}</span>
            <br />
            <span className="receipt__value text">{this.getFrequency().recurring}</span>
          </p>
          <p className="receipt__date">
            <br />
            {date.format('MMM').toUpperCase()}
            <br />
            <span className="nowrap-text">{date.date()}, {date.year()}</span>
          </p>

          {this.renderOptions()}
        </div>
      </div>
    );
  }
}

export default ScheduleReceipt;


// WEBPACK FOOTER //
// ./src/components/schedule/schedule-receipt.js